import React from 'react';
import i18n from '@/i18n/config';
import { Input } from '@heroui/react';

interface FilterScoreRangeProps {
  label: string;
  value: string; // "min,max" format or empty string
  onChange: (value: string) => void;
  className?: string;
}

export function FilterScoreRange({ label, value, onChange, className = 'w-48' }: FilterScoreRangeProps) {
  // Parse value into min and max
  const [min, max] = React.useMemo(() => {
    if (!value || value.trim() === '') {
      return ['', ''];
    }
    const parts = value.split(',');
    return [parts[0]?.trim() || '', parts[1]?.trim() || ''];
  }, [value]);

  const handleMinChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newMin = e.target.value;
      const newValue = newMin && max ? `${newMin},${max}` : newMin ? newMin : max ? `,${max}` : '';
      onChange(newValue);
    },
    [max, onChange]
  );

  const handleMaxChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newMax = e.target.value;
      const newValue = min && newMax ? `${min},${newMax}` : newMax ? `,${newMax}` : min ? min : '';
      onChange(newValue);
    },
    [min, onChange]
  );

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label className="text-sm font-medium text-default-700">{label}</label>
      <div className="flex items-center gap-2">
        <Input
          type="number"
          size="sm"
          placeholder={i18n.t('copy.min')}
          value={min}
          onChange={handleMinChange}
          min="0"
          max="1"
          step="0.01"
          className="flex-1"
          aria-label={`${label} minimum`}
        />
        <span className="text-default-400 text-sm">-</span>
        <Input
          type="number"
          size="sm"
          placeholder={i18n.t('copy.max')}
          value={max}
          onChange={handleMaxChange}
          min="0"
          max="1"
          step="0.01"
          className="flex-1"
          aria-label={`${label} maximum`}
        />
      </div>
    </div>
  );
}

export default FilterScoreRange;

